import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';

export const getRealEstatePpr = (realEstateId: string) => {
  return instance(true, PPR_API_URL)
    .get(`task/statusesByRealEstate/${realEstateId}`)
    .then((response) => response.data);
};

export const getListByRealEstatePpr = (config?: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get(`task/listByRealEstate`, config)
    .then((response) => response.data);
};
